import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';

import Navigation from 'components/molecules/Navigation';
import Button from 'components/atoms/Button';

import logo from 'images/logo-yuanyu.svg';
// import logoBlue from 'images/logo-oly-blue.png';
// import logo100 from 'images/100years_logo.png';
import omds from 'images/logo-omds.png';
// import fbIcon from 'images/facebook.svg';
// import igIcon from 'images/instagram.svg';
// import searchIcon from 'images/search.svg';
import menuIcon from 'images/menu.svg';

import { toggleNavi } from 'actions/global';
import { logout } from 'actions/auth';

import styles from './index.css';


const Header = ({
	naviToggle,
	onToggle,
	authorized,
	onLogout,
	name,
	credit,
}) => (
	<header className={styles.header}>
		<div className={styles.headerWrap}>
			<div className={styles.headerTop}>
				<a href="https://www.yuanyu.tw/camera/">
					<img src={omds} alt="" style={{ width: '100px', height: 'auto' }} />
				</a>
				<div>
					<Link to="/process">註冊流程教學</Link> /
					{
						authorized === true ?
							<span>
								<Link to="/member"> 嗨，{name}</Link> /
								<a href={process.env.NODE_ENV === 'production' ? 'https://shop.yuanyu.tw/user/bonus' : 'https://shop-yuanyu.25demo.com/user/bonus'} style={{ color: 'red' }}>目前紅利：{credit} 點</a> /
								<Button color="link" onClick={onLogout}>登出</Button>
							</span>
							:
							<span>
								<Link to="/login"> 登入</Link> /
								<Link to="/signup"> 註冊</Link>
							</span>
					}
					<a href="https://www.yuanyu.tw/tw">
						<img src={logo} alt="" style={{ width: '100px', height: 'auto' }} />
					</a>
				</div>
			</div>
			<div className={styles.headerBottom}>
				<button className={styles.menu} onClick={() => onToggle(true)}>
					<img src={menuIcon} alt="" />
				</button>
				<a href="https://www.yuanyu.tw/camera/">
					<img src={omds} alt="" />
				</a>
				{
					/*
					<a href="http://www.yuanyu.tw/" className={styles.pcHidden}>
						<img src={logo} alt="" />
					</a>
					*/
				}
				<Navigation naviToggle={naviToggle} />
			</div>
		</div>
	</header>
);

function mapStateToProps({
	global: { naviToggle },
	auth: { token: { accessToken } },
	members: { name, credit },
}) {
	return {
		authorized: accessToken !== '',
		naviToggle,
		name,
		credit,
	};
}

function mapDispatchToProps(dispatch) {
	return {
		onToggle: toggle => dispatch(toggleNavi(toggle)),
		onLogout: () => dispatch(logout()),
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(Header);



// WEBPACK FOOTER //
// ./src/components/organisms/Header/index.js